import { Component, OnInit } from '@angular/core';
import { array_message_translations } from './translations';
import { NavigatorService } from '../navigator.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})


export class LoginComponent implements OnInit  {
  loginForm = new FormGroup({
    Email: new FormControl(),
  });
  translations = array_message_translations;
  selectedLanguagearray: string[] = [];
  userLanguage = '' 
  constructor( private navigatorService: NavigatorService,private router: Router) {
  }
  ngOnInit(): void {
    window.localStorage.removeItem("region")
    var lang:string = (navigator.language).substring(0, 2);
    //alert(lang);
    const message = array_message_translations[lang as keyof typeof array_message_translations];
    this.selectedLanguagearray = this.translations[lang.toString() as keyof typeof this.translations];
    if (!this.selectedLanguagearray) {
      this.selectedLanguagearray = this.translations["en"];; // Fallback to English message
    }
  }
  onSubmit()
  {
    // alert('hi');
    // window.localStorage.setItem("region-through",'login');
    // window.localStorage.removeItem("region");
    // if(this.loginForm.controls.Email.value?.includes('-apac@'))
    // {
    //   window.localStorage.setItem("region",'apac');
    //   window.location.href = '/apac'
    // }
    // else  if(this.loginForm.controls.Email.value?.includes('-emea@'))
    // {
    //   window.localStorage.setItem("region",'emea');
    //   window.location.href = '/emea'
    // }
    // else  if(this.loginForm.controls.Email.value?.includes('-americas@'))
    // {
    //   window.localStorage.setItem("region",'americas');
    //   window.location.href = '/americas'
    // }
    // else
    // {
    //   window.localStorage.removeItem("region");
    //   this.router.navigate(['/login']);
    // }
  }
}
